<div class="row d-flex justify-content-center">
  <div class="card d-inline-flex mb-0 input-form">
    <div class="card-body d-inline-flex flex-column align-items-end p-0">
      <button type="button" class="btn-close" (click)="close()" aria-label="Close">
      </button>
    </div>
    <div class="card-body d-inline-flex flex-column align-items-center pt-0">
      <h4 class="mb-0">{{ translate("scan-qr-code") }}</h4>
    </div>
    <div *ngIf="!errorState" id="scan" class="mx-auto">
      <video #video autoplay class="video" disablePictureInPicture></video>
      <canvas #canvas class="d-none"></canvas>
    </div>
    <div *ngIf="errorState" id="errorState" class="d-flex justify-content-center align-items-center mx-auto error-overlay">
        <button class="btn round btn-primary" id="retryScan" (click)="retryScan()">{{ translate("error.try-again") }}</button>
    </div>
    <div class="notification-bar-container">
      <au-notification-bar #notificationBar id="webcam-error-notification-bar"></au-notification-bar>
    </div>
  </div>
</div>
